import { axios } from 'system/axios'

import { WorkoutFilterEntity } from '../entities/WorkoutFilterEntity'

export type WorkoutFilter = WorkoutFilterEntity

export const getWorkoutFilters = () => axios.get<WorkoutFilter[]>('/workout-filter')
